
import { Component, mixins } from 'nuxt-property-decorator';
import WebsiteNavigationLinkMixin from './WebsiteNavigationLinkMixin';
import { PageType } from '../../../services/fourwaves/models';

@Component({})
export default class WebsiteMobileNavigationLink extends mixins(WebsiteNavigationLinkMixin) {
  readonly PageType = PageType;
}
